import React from 'react'
import { useAuth } from './Auth//use-auth'
import clsx from 'clsx'
import Reservations from './Reservations'
import DefaultDate from './components/DefaultDate'
import DelayingAppearance from './components/DelayingAppearance'
import Search from './Search'
import CssBaseline from '@material-ui/core/CssBaseline'
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import IconButton from '@material-ui/core/IconButton'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import SwipeableTemporaryDrawer from './SwipeableTemporaryDrawer'
import PopoverPopupState from './PopoverPopupState'
import Hidden from '@material-ui/core/Hidden'
import { useHistory } from 'react-router-dom'
//import packageJson from '../package.json'
import { fade, makeStyles } from '@material-ui/core/styles'
import SearchContext from './SearchContext'
const useStyles = makeStyles(theme => ({
  // grow: {
  //   flexGrow: 1
  // },
  toolbar: {
    display: 'flex',
    flex: 1,
    justifyContent: 'space-between'
  },

  // layout: {
  //   width: 750,
  //   marginLeft: theme.spacing(2),
  //   marginRight: theme.spacing(2),
  //   [theme.breakpoints.up(750 + theme.spacing(2) * 2)]: {
  //     width: 'auto',
  //     marginLeft: 'auto',
  //     marginRight: 'auto'
  //   }
  // },
  // menuButton: {
  //   marginRight: theme.spacing(4)
  // },

  // title: {
  //   display: 'none',
  //   [theme.breakpoints.up('sm')]: {
  //     display: 'block'
  //   }
  // },
  calendar: {
    display: 'flex',
    flex: 2,
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      display: 'none',
      marginLeft: theme.spacing(1),
      width: 'auto'
    }
  },
  search: {
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: fade(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: fade(theme.palette.common.white, 0.25)
    },
    alignItems: 'stretch',
    marginRight: theme.spacing(2),
    marginLeft: 0,
    width: '100%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(3),
      width: 'auto'
    }
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },

  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '20ch'
    }
  },
  sectionDesktop: {
    display: 'none',
    [theme.breakpoints.up('md')]: {
      display: 'flex'
    }
  },
  sectionMobile: {
    display: 'flex',
    [theme.breakpoints.up('md')]: {
      display: 'none'
    }
  }
}))

const MainBoard = props => {
  const classes = useStyles()
  const [open, setOpen] = React.useState(true)
  const { user, setUser } = useAuth()
  const history = useHistory()
  // todo statusvälja jaoks
  const { globalFilter, SetGlobalFilter, selectedDate } = React.useContext(
    SearchContext
  )
  const handleDrawerOpen = () => {
    setOpen(true)
  }

  // React.useEffect(() => {
  //   if (!user) {
  //     window.alert('Kasutaja tuvastamata', user)
  //     props.history.push('/')
  //   }
  // }, [user])
  return (
    ('user' && (
      <React.Fragment>
        {/*<Container component='main' maxWidth='lg'>*/}
        <AppBar position='fixed'>
          <Toolbar className={classes.toolbar}>
            <SwipeableTemporaryDrawer />

            <DefaultDate />
            <Hidden xsDown>
              <Search tooltip={'Sisesta auto nr'} placeHolder={globalFilter} />
            </Hidden>

            <PopoverPopupState />
          </Toolbar>
        </AppBar>

        <Grid key={'Grid1'} item xs={12} md={12} lg={12}>
          {JSON.stringify(user, '', 2)}
          {'user' && <Reservations />}
        </Grid>

        {/* </Container> */}
      </React.Fragment>
    )) || (
      <React.Fragment>
        <DelayingAppearance />
      </React.Fragment>
    )
  )
}

export default MainBoard
// actualTime={JSON.stringify(selectedDate + '')}
// <Container maxWidth='xl' className={classes.container}>  </Container>
// return (
//   user && (
//     <React.Fragment>
//       {/*<Container component='main' maxWidth='lg'>*/}
//       <AppBar position='fixed'>
//         <Toolbar>
//           <SwipeableTemporaryDrawer />

//           <div className={classes.search}>
//             <DefaultDate />
//           </div>
//           <div className={classes.search}>
//             <Search
//               tooltip={'Sisesta auto nr'}
//               placeHolder={'Otsi autot...'}
//             />
//           </div>
//           <div className={classes.search}>
//             <PopoverPopupState />
//           </div>
//         </Toolbar>
//       </AppBar>

//       <Grid item xs={12} md={12} lg={12}>
//         {user && <Reservations />}
//       </Grid>
//       {/* </Container> */}
//     </React.Fragment>
//   )
// )
